import { Outlet, NavLink, Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  LayoutDashboard,
  Link2,
  Wallet,
  User,
  TrendingUp,
  ArrowLeft,
  Menu,
  X,
} from 'lucide-react';
import { cn } from '@/utils';
import { ThemeToggle } from '@/components/ui/theme-toggle';

const navItems = [
  { to: '/parceiro', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/parceiro/comissoes', label: 'Comissões', icon: TrendingUp },
  { to: '/parceiro/saques', label: 'Saques', icon: Wallet },
  { to: '/parceiro/links', label: 'Links & Divulgação', icon: Link2 },
  { to: '/parceiro/perfil', label: 'Perfil do Parceiro', icon: User },
];

export function PartnerLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // Fecha o menu mobile automaticamente ao trocar de rota
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-background text-foreground overflow-hidden">
      {/* Backdrop Mobile (< lg) */}
      {mobileOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/60 backdrop-blur-xs lg:hidden transition-opacity"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Drawer Lateral / Sidebar */}
      <aside
        className={cn(
          'bg-card border-r border-border p-4 flex flex-col justify-between transition-all duration-300 w-64',
          'fixed inset-y-0 left-0 z-50 lg:static lg:z-auto',
          mobileOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full lg:translate-x-0'
        )}
      >
        <div>
          <div className="mb-6 flex items-center justify-between">
            <div>
              <Link
                to="/dashboard"
                onClick={() => setMobileOpen(false)}
                className="flex items-center gap-2"
              >
                <img src="/logo.png" alt="Medikei" className="h-7 w-auto" />
              </Link>
              <p className="text-[11px] text-muted-foreground font-bold mt-1 uppercase tracking-wider">
                Programa Indique e Ganhe
              </p>
            </div>

            {/* Botão de Fechar Mobile */}
            <button
              onClick={() => setMobileOpen(false)}
              className="lg:hidden p-2 rounded-xl text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
              aria-label="Fechar menu"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <nav className="space-y-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-medium transition-all',
                    isActive
                      ? 'bg-primary/10 text-primary font-semibold'
                      : 'text-muted-foreground hover:bg-muted/70 hover:text-foreground'
                  )
                }
              >
                <item.icon className="w-4 h-4 shrink-0" />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>

        <div className="pt-4 border-t border-border">
          <Link
            to="/dashboard"
            onClick={() => setMobileOpen(false)}
            className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-xs font-semibold text-muted-foreground hover:bg-muted hover:text-foreground transition-all"
          >
            <ArrowLeft className="w-4 h-4 shrink-0" />
            <span className="truncate">Voltar ao Portal do Paciente</span>
          </Link>
        </div>
      </aside>

      {/* Conteúdo Principal */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Header Superior Mobile & Desktop */}
        <header className="h-16 bg-card border-b border-border flex items-center justify-between px-4 sm:px-6 shrink-0 lg:hidden">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setMobileOpen(true)}
              className="p-2 rounded-xl hover:bg-muted text-foreground transition-colors"
              aria-label="Abrir menu"
            >
              <Menu className="w-5 h-5" />
            </button>
            <img src="/logo.png" alt="Medikei" className="h-6 w-auto" />
          </div>

          <div className="flex items-center gap-2">
            <ThemeToggle />
          </div>
        </header>

        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}